import { render } from "./LearningHubCourses.vue?vue&type=template&id=2ebc02f9"
import script from "./LearningHubCourses.vue?vue&type=script&lang=js"
export * from "./LearningHubCourses.vue?vue&type=script&lang=js"

import "./LearningHubCourses.vue?vue&type=style&index=0&id=2ebc02f9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__